// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup_popup__1Qz7t","fade-in":"Popup_fade-in__6ldQW"};